import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { useDebounce } from "../../utils/useDebounce";
import { useFormContext } from "../../Form";
import { observer } from "mobx-react-lite";
import { useArticleHeaderContext } from "../..";
import { flatMap } from "lodash";
let MAXIMUM_VIEWABLE_VALUES = 20;
// ** TODOs **
// - Make the component accessibile. Doesn't work with a keyboard if there are sub categories.
export const FutureSelectFilter = observer(({ onChange, options, label, direction = "right", name, clearLabel = "All", isClearable = true, id, }) => {
    useEffect(() => {
        if (options.length > MAXIMUM_VIEWABLE_VALUES) {
            console.warn(`You have more than ${MAXIMUM_VIEWABLE_VALUES} options in ${label} component, you should be using the Typeahead component`);
        }
    });
    const { loading } = useArticleHeaderContext();
    const { values } = useFormContext();
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [selected, setSelected] = useState(null);
    useEffect(() => {
        if (loading || options.length === 0)
            return;
        const value = values.get(name);
        if (value && !selected) {
            let filteredOptions = options.filter((option) => option.value === value);
            // We might have chosen a sub-option
            if (filteredOptions.length === 0) {
                filteredOptions = flatMap(options, (option) => option.subOptions || []).filter((subOption) => subOption.value === value);
            }
            if (filteredOptions.length === 0)
                return;
            const selection = {
                name: filteredOptions[0].label || "",
                value: filteredOptions[0].value || "",
            };
            setSelected(selection);
        }
    }, [values, JSON.stringify(options), name, selected, loading]);
    /* TODO useRef */
    const [hoverId, setHoverId] = useState(null);
    const debouncedHoverId = useDebounce(hoverId, 100);
    const elementRef = useRef(null);
    const mouseDownHandler = useCallback((ev) => {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    const keyFunctions = useCallback((event) => {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, [setIsMenuVisible]);
    useEffect(() => {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return () => {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [mouseDownHandler, isMenuVisible, keyFunctions]);
    const onSelect = (option) => {
        const selection = {
            name: option ? option.label : "",
            value: option ? option.value : "",
        };
        values.set(name, selection.value ? selection : "");
        setSelected(option ? selection : null);
        if (onChange) {
            onChange({
                name,
                selected: option ? selection : null,
            });
        }
        setIsMenuVisible(!isMenuVisible);
        setHoverId(null);
    };
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: () => setIsMenuVisible(!isMenuVisible), label: label, value: selected && selected.name },
            React.createElement("ul", { className: `affectBar--menu affectBar--menu--${direction}` },
                isClearable && (React.createElement("li", null,
                    React.createElement("span", { onKeyPress: () => onSelect(null), onClick: () => onSelect(null), tabIndex: 0, role: "button", "aria-disabled": loading }, clearLabel))),
                options &&
                    options.map((option) => (React.createElement("li", { key: option.label, onMouseEnter: () => {
                            setHoverId(option.label);
                        }, onMouseLeave: () => {
                            setHoverId(null);
                        } },
                        React.createElement("span", { onClick: () => onSelect(option), tabIndex: 0, role: "button" }, option.label),
                        (option.label === hoverId ||
                            option.label === debouncedHoverId) &&
                            !!option.subOptions && (React.createElement("ul", { className: `affectBar--menu submenu ${option.label !== hoverId ? "submenu-closing" : ""}` }, option.subOptions.map((option) => (React.createElement("li", { key: option.label },
                            React.createElement("span", { onClick: () => onSelect(option) }, option.label)))))))))))));
});
